import { useState, useEffect, useCallback } from 'react'
import { appsyncQuery } from '../api/appsync-client.js'
import { PREP_CORE_IDS } from '../cards/preparation/prepCardDefinitions.js'

const GET_CANVAS = `
  query GetCanvas {
    getCanvas {
      userId layout updatedAt
    }
  }
`

const UPDATE_CANVAS = `
  mutation UpdateCanvas($layout: [String!]!) {
    updateCanvas(layout: $layout) {
      userId layout updatedAt
    }
  }
`

export function useCanvas({ enabled = true }) {
  const [layout, setLayout] = useState(PREP_CORE_IDS)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  useEffect(() => {
    if (!enabled) return
    appsyncQuery(GET_CANVAS)
      .then((data) => setLayout(data.getCanvas.layout || PREP_CORE_IDS))
      .catch((err) => {
        console.error('Failed to load canvas:', err)
        setError(err)
      })
      .finally(() => setLoading(false))
  }, [enabled])

  const saveCanvas = useCallback(async (newLayout) => {
    await appsyncQuery(UPDATE_CANVAS, { layout: newLayout })
    setLayout(newLayout)
  }, [])

  return { layout, loading, error, saveCanvas }
}
